<template>
  <div class="content">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <div class="row">
            <div class="col-md-9">
              <h4 class="card-title">
            
            <strong
              >{{ title }}
             </strong
            >
          </h4>
            </div>
            <div class="col-md-3">
              <button
                type="button"
                class="btn btn-info btn-sm btn-fill"
                @click="goBack"
                style="
                  border-radius: 25px !important;
                  background: #651366 !important;
                "
              >
                <strong>Volver</strong>
              </button>
            </div>
          
         

          </div>
          <div class="row">
            
          </div>
         
          <card>
            <div class="h-100 mt-4" style="">
              <div class="col-md-12 mb-3">
                <div
                  class="card-body justify-content-center d-flex"
                  style="
                    background-color: #f8f8f8;
                    border-radius: 20px !important;
                    box-shadow: 0px 5px 5px 0px rgba(0, 0, 0, 0.5);
                  "
                >
                  <div
                    class="row justify-content-center justify-content-sm-start col-12"
                  >
                    <div class="col-2 col-sm-2 col-10 px-0">
                      <img
                        v-if="
                          form_update.vehicle.url_image != null &&
                          form_update.vehicle.url_image != undefined &&
                          form_update.vehicle.url_image != '' &&
                          form_update.vehicle.url_image != 'prueba'
                        "
                        class="img-fluid mx-auto d-block mt-2"
                        :src="form_update.vehicle.url_image"
                        onerror="this.onerror=null;src=this.default_img"
                        style="
                          text-align: center;
                          border-radius: 20px;
                          height: 120px;
                        "
                      />
                      <img
                        v-else
                        class="img-fluid mx-auto d-block mt-2"
                        src="https://play-lh.googleusercontent.com/Fa-hPHOekHE_3QxlVqjlnz1SCnwEye8BAVsqcHX4tzFTdiY9hM6U1FO1hc1YyTYWh0o=s200"
                        style="
                          text-align: center;
                          border-radius: 20px;
                          height: 120px;
                        "
                      />
                    </div>
                    <div
                      class="col-sm-3 col-10 text-center text-sm-start px-2 mt-3"
                    >
                      <h5
                        class="card-title"
                        style="font-size: 16px; color: black !important"
                      >
                        <strong>Color: {{ form_update.vehicle.color }}</strong>
                      </h5>
                      <h5
                        class="card-title"
                        style="font-size: 16px; color: black !important"
                      >
                        <strong>Modelo: {{ form_update.vehicle.name }}</strong>
                      </h5>
                      <h5
                        class="card-title"
                        style="font-size: 16px; color: black !important"
                      >
                        <strong>Año: {{ form_update.vehicle.year }}</strong>
                      </h5>
                      <h5
                        class="card-title"
                        style="font-size: 16px; color: black !important"
                      >
                        <strong>Placa: {{ form_update.vehicle.plate }}</strong>
                      </h5>
                    </div>

                    <div class="col-2 col-sm-2 col-10 mt-3 px-0">
                      <img
                        v-if="
                          form_update.user.url_image != null &&
                          form_update.user.url_image != undefined &&
                          form_update.user.url_image != '' &&
                          form_update.user.url_image != 'prueba'
                        "
                        class="img-fluid mx-auto d-block mt-2"
                        :src="form_update.user.url_image"
                        style="
                          height: 80px;
                          width: 80px;
                          text-align: center;
                          border-radius: 50px;
                        "
                      />
                      <img
                        v-else
                        class="img-fluid mx-auto d-block mt-2"
                        src="https://static.vecteezy.com/system/resources/thumbnails/008/442/086/small_2x/illustration-of-human-icon-user-symbol-icon-modern-design-on-blank-background-free-vector.jpg"
                        onerror="this.onerror=null;src=this.default_img"
                        style="
                          height: 80px;
                          width: 80px;
                          text-align: center;
                          border-radius: 50px;
                        "
                      />
                    </div>
                    <div
                      class="col-sm-3 col-10 align-items-center row text-center text-sm-start"
                    >
                      <h5 style="color: black !important">
                        <strong
                          >{{ form_update.user.first_name }}
                          {{ form_update.user.last_name }}</strong
                        >
                      </h5>
                      <p style="color: black !important; font-size: 16px">
                        Fecha de inspección: {{ formatDate2(form_update.date) }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div class="container">
                <div class="row">
                  <div class="col-md-6">
                    <h4>Datos del vehículo</h4>
                  </div>

                  <div class="col-md-6">
                    <h4>
                      Hora de inspección:
                      {{ formatTime(form_update.inspection_time) }}
                    </h4>
                    <h4></h4>
                  </div>
                  <div class="col-md-6">
                    <label>Kilometraje:</label>
                    <div class="position-relative">
                      <input
                        class="form-control no-spinner"
                        type="number"
                        step="0.1"
                        v-model="form_update.mileage"
                      />
                      <span class="position-absolute top-50 end-0 translate-middle-y pe-3" style="pointer-events: none; color: rgb(179 186 191);">Km</span>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div>
                      <label>Fecha del cambio de aceite</label>

                      <input
                        type="date"
                        v-model="form_update.oil_change_date"
                        class="form-control my-input-style"
                      />
                    </div>
                    <div>
                      <br />
                      <label>Tipo de aceite:</label>
                      <input
                        class="form-control"
                        v-model="form_update.oil_type"
                      />
                      <br />
                      <div class="text-center">
                        <button
                          type="button"
                          class="btn btn-primary"
                          @click="saveData(form_update)"
                          style="
                            background: #651366 !important;
                            border-radius: 15px !important;
                          "
                        >
                          Actualizar datos
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <br />
            <div style="overflow: hidden !important">
              <h3>
                Ítems de inspección
              </h3>
              <br />

              <div
                v-for="(category, index) in InspectionsTmp.categories"
                :key="index"
                class="accordion accordion-flush col-12 mb-3"
                :id="'accordionFlushExample' + index"
                style="background: white !important"
              >
                <div
                  class="accordion-item"
                  style="background: white !important"
                >
                  <h2
                    class="accordion-header"
                    id="flush-heading"
                    style="background: white !important"
                  >
                    <button
                      class="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      :data-bs-target="'#flush-collapse' + category.id"
                      aria-expanded="false"
                      aria-controls="flush-collapse"
                      style="
                        border-radius: 20px !important;
                        
                        box-shadow: 0px 3px 3px 0px rgba(0, 0, 0, 0.5);
                        
                      "
                    >
                      {{ category.name }} - (Valor {{ category.value }} puntos)
                    </button>
                  </h2>
                  <div
                    :id="'flush-collapse' + category.id"
                    class="accordion-collapse collapse"
                    aria-labelledby="flush-heading"
                    data-bs-parent="#accordionFlushExample"
                  >
                    <br />
                    <div class="accordion-body">
                      <div
                        class="ml-3"
                        v-for="(
                          inspection_parameter, index
                        ) in category.inspection_parameters"
                        :key="index"
                      >
                        <div class="row p-1">
                          <div class="col-md-7">
                            <span>
                              {{ inspection_parameter.name }}
                            </span>
                            <span style="font-size: 12px"
                              >(Valor: {{ inspection_parameter.value }})</span
                            >
                          </div>
                          <div class="col-md-3">
                            <!--<input
                          type="number"
                          class="form-control"
                          v-model="
                            inspection_parameter.inspection_detail.result
                          "
                        />-->
                            <select
                              class="form-select"
                              v-model="
                                inspection_parameter.inspection_detail.result
                              "
                            >
                              <option
                                v-for="option in valueResults"
                                :key="option.id"
                                :value="option.value"
                              >
                                <span>{{ option.name }}</span>
                              </option>
                            </select>
                            <p
                              style="font-size: 12px"
                              class="mx-auto text-center"
                            >
                              Resultado:
                              {{
                                inspection_parameter.inspection_detail.result
                              }}%
                            </p>
                          </div>
                          <div class="col-md-2">
                            <div class="input-group-append">
                             
                              <button
                                class="btn btn-primary m-1"
                                type="button"
                                @click.prevent="
                                  saveElement(
                                    inspection_parameter.inspection_detail
                                      .result,
                                    inspection_parameter.inspection_detail
                                      .id_inspection,
                                    inspection_parameter.inspection_detail
                                      .id_inspection_parameter
                                  )
                                "
                                style="
                                  background: #f76e2a !important;
                                  border-radius: 15px !important;
                                "
                              >
                                <v-icon name="save" fill="white"></v-icon>
                              </button>
                              <button
                            
                            class="btn btn-outline-secondary m-1"
                            @click.prevent="
                              openModal(
                                inspection_parameter.inspection_detail
                              )
                            "
                            type="button"
                            style="
                              background: orange !important;
                              border-radius: 15px !important;
                            "
                          >
                            <strong>
                              <v-icon name="pen" fill="white"></v-icon>
                            </strong>
                          </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <br />
              </div>

              
            </div>

            <div
              class="modal fade"
              id="observationModal"
              tabindex="-1"
              aria-labelledby="observationModalLabel"
              aria-hidden="true"
            >
              <div class="modal-dialog">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title" id="observationModalLabel">
                      Agregar observación
                    </h5>
                    <button
                      type="button"
                      class="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>
                  <div class="modal-body">
                    <textarea
                      class="form-control"
                      v-model="form_updateInspections.observation"
                    ></textarea>
                  </div>
                  <div class="modal-footer">
                    <button
                      type="button"
                      class="btn btn-secondary"
                      data-bs-dismiss="modal"
                      style="
                        border-radius: 15px !important;
                        background: #651366 !important;
                      "
                    >
                      Cerrar
                    </button>
                    <button
                      type="button"
                      class="btn btn-primary"
                      @click="saveObservation(form_updateInspections)"
                      style="
                        background: #f76e2a !important;
                        border-radius: 15px !important;
                      "
                    >
                      Guardar
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </card>
          <button
            type="button"
            data-toggle="tooltip"
            data-placement="top"
            title="Crear nuevo"
            :class="'btn btn-fill btn-info mx-auto'"
            @click.prevent="goView()"
            style="
              border-radius: 25px !important;
              background: #651366 !important;
              left: 40% !important;
              position: relative !important;
            "
          >
            <span style="color: white; font-size: 14px; padding: 28px">
              <strong>Resultados</strong></span
            >
          </button>
         
        </div>

        <link
          href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css"
          rel="stylesheet"
          integrity="sha384-EVSTQN3/azprG1Anm3QDgpJLIm9Nao0Yz1ztcQTwFspd3yD65VohhpuuCOmLASjC"
          crossorigin="anonymous"
        />
      </div>
    </div>
  </div>
</template>

<script>
function clearAccents(cadena) {
  let chars = {
    á: "a",
    é: "e",
    í: "i",
    ó: "o",
    ú: "u",
    à: "a",
    è: "e",
    ì: "i",
    ò: "o",
    ù: "u",
    ñ: "n",
    Á: "A",
    É: "E",
    Í: "I",
    Ó: "O",
    Ú: "U",
    À: "A",
    È: "E",
    Ì: "I",
    Ò: "O",
    Ù: "U",
    Ñ: "N",
  };
  let expr = /[áàéèíìóòúùñ]/gi;
  let res = cadena.replace(expr, function (e) {
    return chars[e];
  });
  return res;
}

import { mapState } from "vuex";
import { mapActions } from "vuex";
import Swal from "sweetalert2";
import "sweetalert2/src/sweetalert2.scss";
import LTable from "src/components/Table.vue";
import DatePicker from "vue2-datepicker";
import Card from "src/components/Cards/Card.vue";
import Multiselect from "vue-multiselect";
import moment from "moment";
import { data } from "jquery";

export default {
  components: {
    LTable,
    Card,
    Multiselect,
    DatePicker,
  },
  data() {
    return {
      //LABELS
      title: "Detalles de inspección",
      description: "Podrás gestionar a los administradores de la plataforma",
      buttonNewLabel: "Crear nueva inspección",
      buttonNewUrl: "InspectionsNew",
      buttonEditUrl: "InspectionsEdit",
      finderLabel: "Placa del vehículo",
      observation: "",
      result: "",
      //VARIABLE
      valueResults: [
        { id: 1, name: "Bueno", value: 100 },
        { id: 2, name: "Regular", value: 50 },
        { id: 3, name: "Malo", value: 0 },
      ],
      form_update: {
        id: 0,
        type_vehicle: {},
        type_brand: {},
        type_model: {},
        user: {},
        name: "",
        plate: "",
        url_image: "",
        year: "",
        number_door: "",
        color: "",
        air_conditioning: "",
        smoke_glasses: "",
      },
      form_updateInspections: {
        observation: "",
      },
      finder: "",
      metaInfo: {},
      sortOrder: "asc",
      // sortKey: "first_name",
      default_img: "public/img/logochami.png",
      //FILTERS
      active_model: "",
      activeTmp: [
        {
          id: 1,
          name: "Activo",
        },
        {
          id: 0,
          name: "Inactivo",
        },
      ],

      //TABLE DATA
      tableData: {
        columns: [
          {
            name: "Nombre",
            key: "name",
          },
          {
            name: "Apellido",
            key: "last_name",
          },
          {
            name: "Cédula",
            key: "dni",
          },
          {
            name: "Correo",
            key: "email",
          },
          {
            name: "Teléfono celular",
            key: "phone_1",
          },
          {
            name: "Fecha inscripción",
            key: "created_at",
          },

          {
            name: "Acciones",
            key: "actions",
          },
        ],
        data: [],
      },
      //DATA Variables
      Users: [],

      InspectionsTmp: {},

      //TABLE Buttons
      buttons: [
        {
          icon: "eye",
          icon_negative: "eye",
          type_button: "btn-info",
          tooltip: "Ver Detalles",
          url: "/admin/users/admins/edit",
          type_action: "go_url",
          action: "go_url",
          fill_icon: "#f76e2a",
          background_color: "white",
        },
        {
          icon: "check-square",
          icon_negative: "minus-square",
          type_button: "btn-warning",
          tooltip: "Cambiar Estatus",
          url: "",
          type_action: "go_method",
          action: "changeStatus",
          fill_icon: "#651366",
          background_color: "white",
        },
        {
          icon: "trash",
          icon_negative: "trash",
          type_button: "btn-danger",
          tooltip: "Eliminar administrador",
          url: "",
          type_action: "go_method",
          action: "rejectedStatus",
          fill_icon: "#8CC540",
          background_color: "white",
        },
      ],
    };
  },
  computed: {
    ...mapState({
      me: (state) => state.auth.me,
      me_rol: (state) => state.auth.me_rol,
    }),
    sortOptions() {
      return [];
    },
    formattedDate() {
      const today = moment(); // Use moment to create a moment object
      return today.format("DD-MM-YYYY"); // Format using moment's format method
    },
    // rows() {
    //   return this.UsersTmp.length;
    // },
  },
  mounted() {
    this.getElement(this.$route.params.id);
    console.log("el id que llega loadelements", this.$route.params.id);
    // this.loadElements(this.$route.params.id);
  },
  // updated() {
  //   console.log(this.user);
  // },
  methods: {
    ...mapActions(["getData", "changeStatusData", "createData", "updateData"]),
    goBack() {
      window.history.go(-1);
    },
    goNew() {
      this.$router.push({ name: this.buttonNewUrl });
    },
    goView(id) {
      this.$router.push({
        path: "/admin/inspections/edit/" + this.$route.params.id,
      });
      console.log(id, "id del edit nuevo");
    },
    cleanFilters() {
      this.finder = "";
      this.active_model = "";
      this.loadElements();
    },

    // formatDate(date) {
    //   return moment(date).format("DD/MM/YYYY");
    // },
    formatDate(date) {
      return moment(date).format("DD [de ]MMMM [de] YYYY"); // Ejemplo: 27 de Mayo de 2024
    },
    formatDate2(date) {
      return moment(date).format("DD-MM-YYYY"); // Ejemplo: 27 de Mayo de 2024
    },
    formatDate3(date) {
      return moment(date).format("YYYY-MM-DD"); // Ejemplo: 27 de Mayo de 2024
    },
    // formatTime(timeString) {
    //       const [hours, minutes] = timeString.split(':');
    //       return `${hours}:${minutes.padStart(2, '0')}`; // Asegura que los minutos siempre tengan dos dígitos
    //     },
    formatTime(timeString) {
      const [hours, minutes] = timeString.split(":");
      let formattedHours = parseInt(hours);

      // Convertir a formato de 12 horas
      if (formattedHours >= 12) {
        formattedHours -= 12;
        return `${formattedHours}:${minutes.padStart(2, "0")} PM`;
      } else if (formattedHours === 0) {
        // Manejo de la medianoche
        formattedHours = 12;
        return `${formattedHours}:${minutes.padStart(2, "0")} AM`;
      } else {
        return `${formattedHours}:${minutes.padStart(2, "0")} AM`;
      }
    },
    openModal(inspectionDetail) {
      $("#observationModal").modal("toggle");
      this.form_updateInspections = inspectionDetail;
      console.log("Inspection Detail: ", this.form_updateInspections);
      this.modalActiveSave = true;
    },
    disableFutureDates(date) {
      return date > Date();
    },

    getElement(id) {
      this.loaded = false;
      let data_params = {
        url: "inspection/complete/" + id,
      };
      this.getData(data_params)
        .then((response) => {
          this.form_update = response.data;

          (this.form_updateInspections = response.data),
            (this.Users = response.data);
          this.metaInfo = response.data.meta;
          this.InspectionsTmp = this.Users;

          if (this.form_update.smoke_glasses == 1) {
            this.form_update.smoke_glasses = this.smokeTMP[0];
          }
          if (this.form_update.smoke_glasses == 2) {
            this.form_update.smoke_glasses = this.smokeTMP[1];
          }
          if (this.form_update.air_conditioning == 1) {
            this.form_update.air_conditioning = this.airTMP[0];
          }
          if (this.form_update.air_conditioning == 2) {
            this.form_update.air_conditioning = this.airTMP[1];
          }
          //     this.loadSelects("master/type_brand");
          // this.loadSelects("master/type_vehicle");
          // this.loadSelects("master/type_model");
          // this.loadSelects("user");

          // const selectedTypeModel = this.typeModelTMP.find(model => model.id === this.form_update.id_type_model);
          // this.form_update.type_model = selectedTypeModel;

          // const selectedUser = this.usersTMP.find(user => user.id === this.form_update.id_user);
          // this.form_update.user = selectedUser;

          this.loaded = true;
        })
        .catch((error) => {
          this.loaded = true;
          console.log(error);
        });
    },
    changeStatus(data) {
      let active = data.active === 1 ? 0 : 1;
      let title = data.active === 1 ? "Desactivar" : "Activar";
      let title2 = data.active === 1 ? "Desactivado" : "Activado";
      let text =
        data.active === 1
          ? "¿Estás seguro de desactivarlo ahora?"
          : "¿Estás seguro de activarlo ahora?";
      Swal.fire({
        title: title,
        text: text,
        icon: "question",
        reverseButtons: true,
        showCancelButton: true,
        confirmButtonColor: "#651366",
        cancelButtonColor: "#F76E2A",
        confirmButtonText: "Cambiar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.value) {
          let form = {
            id: data.id,
            url: "user/change_status",
            status: active,
          };
          this.changeStatusData(form)
            .then((response) => {
              if (response.code === 200) {
                this.loadElements();
                data.active = active;
                Swal.fire({
                  title: title2,
                  icon: "success",
                  confirmButtonColor: "#651366",
                });
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
      });
    },
    saveObservation(item) {
      
      let data_form;

      data_form = new FormData();
      data_form.append("id_inspection", item.id_inspection);
      data_form.append("id_inspection_parameter", item.id_inspection_parameter);
      data_form.append("observation", item.observation);

      let form = {
        url: "inspection_detail/update/observation",

      
        data: data_form,
      };
      this.createData(form).then((response) => {
        if (response.code === 200) {
          this.deleting = false;
          Swal.fire({
            title: "Observación agregada correctamente",
            icon: "success",
            showConfirmButton: false,
            showLoaderOnConfirm: true,
            timer: 1000,
          });
          $("#observationModal").modal("hide");
          // const expires_in = moment().format("YYYY-MM-DD HH:mm");
          // const expires_at = moment(expires_in).add(4, 'hours').format("YYYY-MM-DD HH:mm");
          // const expires_at_date = new Date(expires_at);
          // Cookies.remove("id_type_user");
          // Cookies.set("id_type_user", id_type_user, { expires: expires_at_date });
          // location.reload();
          // this.loadElements(this.$route.params.id);
          // this.getElement(this.id_user_logged);
        }
        if(response.code === 404) {
          Swal.fire({
            title: "Guarda primero el resultado de la inspección, y luego agrega una observación",
            icon: "warning",
            showConfirmButton: false,
            showLoaderOnConfirm: true,
            timer: 3000,
          });
          }
      });
    },
    //saveData
    saveData(item) {
      if (!item.oil_type || !item.mileage || !item.oil_change_date) {
        this.$toaster.warning(
          "Por favor completa todos los campos requeridos."
        );
        return; // Detener la ejecución de la función si alguno de los campos está vacío
      }
      console.log(
        "fecha",
        item.oil_change_date,
        "kilometros",
        item.mileage,
        "tipo de aceite",
        item.oil_type
      );
      let data_form;
      data_form = new FormData();
      data_form.append("oil_type", item.oil_type);
      data_form.append("mileage", item.mileage);
      data_form.append(
        "oil_change_date",
        this.formatDate3(item.oil_change_date)
      );

      let form = {
        url: "inspection/update",

        id: item.id,
        data: data_form,
      };
      this.updateData(form).then((response) => {
        if (response.code === 200) {
          this.deleting = false;
          Swal.fire({
            title: "Datos actualizados correctamente",
            icon: "success",
            showConfirmButton: false,
            showLoaderOnConfirm: true,
            timer: 1000,
          });
          // $("#observationModal").modal("hide");
          // const expires_in = moment().format("YYYY-MM-DD HH:mm");
          // const expires_at = moment(expires_in).add(4, 'hours').format("YYYY-MM-DD HH:mm");
          // const expires_at_date = new Date(expires_at);
          // Cookies.remove("id_type_user");
          // Cookies.set("id_type_user", id_type_user, { expires: expires_at_date });
          // location.reload();
          // this.loadElements(this.$route.params.id);
          // this.getElement(this.id_user_logged);
        }
      });
    },
    saveElement(Itemresult, id, idparam) {
      // Obtener el elemento input
      const inputElement = Itemresult;
      const numero = parseInt(inputElement);
      console.log(numero, "aqui esta el valor", id, idparam);
      let data_form;
      data_form = new FormData();
      data_form.append("result", numero);
      data_form.append("id_inspection", id);
      data_form.append("id_inspection_parameter", idparam);

      let form = {
        url: "inspection_detail/save",

        id: this.$route.params.id,
        data: data_form,
      };
      this.createData(form).then((response) => {
        if (response.code === 200) {
          this.deleting = false;
          Swal.fire({
            title: "Resultado registrado correctamente",
            icon: "success",
            showConfirmButton: false,
            showLoaderOnConfirm: true,
            timer: 1000,
          });

          // const expires_in = moment().format("YYYY-MM-DD HH:mm");
          // const expires_at = moment(expires_in).add(4, 'hours').format("YYYY-MM-DD HH:mm");
          // const expires_at_date = new Date(expires_at);
          // Cookies.remove("id_type_user");
          // Cookies.set("id_type_user", id_type_user, { expires: expires_at_date });

          this.loadElements();
          // this.getElement(this.id_user_logged);
        }
      });
    },
    rejectedStatus(data) {
      let title = "Eliminar administrador";

      let text = "¿Estás seguro de eliminar este administrador?";
      Swal.fire({
        title: title,
        text: text,
        icon: "question",
        reverseButtons: true,
        showCancelButton: true,
        confirmButtonColor: "#651366",
        cancelButtonColor: "#F76E2A",
        confirmButtonText: "Eliminar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.value) {
          let form = {
            id: data.id,
            url: "user/change_status",
            status: 2,
          };
          this.changeStatusData(form)
            .then((response) => {
              if (response.code === 200) {
                this.loadElements();
                // data.active = active;
                Swal.fire({
                  title: "El administrador fue eliminado",
                  icon: "success",
                });
                // location.reload();
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
      });
    },
  },
};
</script>

<style>
.accordion {
  border: none !important;
  padding: 0 !important;
}

.accordion-item {
  background-color: #fff !important;
  border-radius: 0 !important;
}

.accordion-header {
  background-color: #eee !important;
  border: none !important;
  box-shadow: none !important;
}

.accordion-header button {
  color: #000 !important;
  font-weight: bold !important;
}

.accordion-body {
  background-color: #fff !important;
  padding: 15px !important;
}

.accordion-item:nth-child(odd) .accordion-collapse.show,
.accordion-item:nth-child(even) .accordion-collapse.show {
  border-radius: 5px !important;
}

.accordion-item:nth-child(odd) .accordion-header {
  background-color: #f8f8f8 !important;
  border-radius: 5px !important;
}

.accordion-item:nth-child(odd) .accordion-collapse.show {
  border-radius: 5px !important;
}

.accordion-item:nth-child(even) .accordion-header {
  background-color: #f8f8f8 !important;
  border-radius: 5px !important;
}

.accordion-item:nth-child(even) .accordion-collapse.show {
  border-radius: 5px !important;
}

/* Ocultar flechas de input number */
.no-spinner::-webkit-inner-spin-button,
.no-spinner::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.no-spinner {
  -moz-appearance: textfield;
  appearance: textfield;
}
</style>
